/** The only host a credit pack Checkout may send the browser to. */
const STRIPE_CHECKOUT_HOST = 'checkout.stripe.com';

/** Leaves the app for a Stripe-hosted Checkout page; throws on any other address. */
export function openCheckout(checkoutUrl: string): void {
  const url = URL.canParse(checkoutUrl) ? new URL(checkoutUrl) : null;
  if (url?.protocol !== 'https:' || url.hostname !== STRIPE_CHECKOUT_HOST) {
    throw new Error('The Checkout URL is not a Stripe Checkout page');
  }
  window.location.href = url.href;
}
